import Page from "src/components/Page";
import { BackButton } from "src/common/components/BackButton";
import PartnerDetails from "./PartnerDetails";

const Partner = () => {
  return (
    <Page title="Company | Smart-CMS">
      <BackButton
        text={'Back to Partners'}
        path="/ocpi/partners"
      />
      <PartnerDetails />
    </Page>
  );
};

export default Partner;